import request from '@/utils/request'
const BASE_URL = '/StBook'

export default {
  getStatusStat(data) {
    return request({
      url: BASE_URL + '/GetStatusStat',
      method: 'post',
      data
    })
  },
  getWarehouseStat(data) {
    return request({
      url: BASE_URL + '/GetWarehouseStat',
      method: 'post',
      data
    })
  },
  getBatchStat(data) {
    return request({
      url: BASE_URL + '/GetBatchStat',
      method: 'post',
      data
    })
  },
  getTurnoverStat(data) {
    return request({
      url: BASE_URL + '/GetTurnoverStat',
      method: 'post',
      data
    })
  },
  getTurnoverStatTotal(data) {
    return request({
      url: BASE_URL + '/GetTurnoverStatTotal',
      method: 'post',
      data
    })
  },
  getBusinessDocList(data) {
    return request({
      url: BASE_URL + '/GetBusinessDocList',
      method: 'post',
      data
    })
  },
  export(data) {
    return request({
      url: BASE_URL + '/Export',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {
      var file = res.data;
      var disposition = res.headers['content-disposition'];
      // 

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    });
  },
  // 出入库流水导出
  getTurnoverStatExport(data) { 
    return request({
      url: BASE_URL + '/GetTurnoverStatExport',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {
      var file = res.data;
      var disposition = res.headers['content-disposition'];
      // 

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    });
  },
  // 现存量合计
  getStatusStatTotal(data) {
    return request({
      url: BASE_URL + '/GetStatusStatTotal',
      method: 'post',
      data
    })
  },
}